export const Rights = [
    "WEB_MODULE_PILOT_TRANSPORT_ORDERS_READ"
]
